import { useQuery } from '@tanstack/react-query';

import { CerberusApi } from '@hcs/cerberus';
import {
  ZipHpiTimeSeriesQueryVariables,
  ZipRpiTimeSeriesDocument,
  ZipRpiTimeSeriesQuery,
  ZipRpiTimeSeriesQueryVariables,
} from '@hcs/types';

import { zipRpiTSQueryToCerberusRpiTS } from '../utils/cerberus-stats.utils';

const QUERY_KEY_ZIP_RPI_TIME_SERIES = 'zip-rpi-time-series';

export const useZipRpiTimeSeries = ({
  zipcode,
  fromDate,
  toDate,
  enabled = true,
}: ZipHpiTimeSeriesQueryVariables & {
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: [QUERY_KEY_ZIP_RPI_TIME_SERIES, zipcode, fromDate, toDate],

    queryFn: async () => {
      const response = await CerberusApi.fetchQuery<
        ZipRpiTimeSeriesQuery,
        ZipRpiTimeSeriesQueryVariables
      >(ZipRpiTimeSeriesDocument, {
        zipcode,
        fromDate,
        toDate,
      });
      return zipRpiTSQueryToCerberusRpiTS(response);
    },

    enabled,
  });
};
